import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://www.optimagrowth.agency";

const SEO = ({ title, description, keywords = "", type = "website" }) => {
  const location = useLocation();
  const siteTitle = "OptimaGrowth";

  const getFullTitle = () => {
    if (!title) return `${siteTitle} | SEO, Marketing Automation & Growth Partner | South Africa`;
    if (title.includes(siteTitle)) return title;
    return `${title} | ${siteTitle}`;
  };

  const fullTitle = getFullTitle();
  const canonicalUrl = `${SITE_URL}${location.pathname}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || ""} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:locale" content="en_ZA" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || ""} />
    </Helmet>
  );
};

export default SEO;
